// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3HKn7","tab":"Tabs_tab__IbweH","tabActive":"Tabs_tabActive__2FKDW"};